import React from "react";

export default function OpenFile(props) {
    const { fileUrl, fileName } = props;
    return (
        <a href={fileUrl} target="_blank" rel="noopener noreferrer" download>
            {fileName}
        </a>
    );
}